// Build58 PlaylistsScreen selection: rotate one representative per curator daily.
export const playlistItemCount = (item) =>
  (item.type === 'TRACK' ? item.trackCount : item.albumCount) || 0;
export function selectFeaturedPlaylist(playlists, currentUsername, now = new Date()) {
  const curators = new Map();
  playlists.forEach((item) => {
    const username = item.username?.trim();
    if (!username || username === currentUsername || playlistItemCount(item) <= 0) return;
    const current = curators.get(username);
    if (!current) curators.set(username, { latest: item.updatedAt, item });
    else {
      if (item.updatedAt > current.latest) current.latest = item.updatedAt;
      if (item.bookmarkCount > current.item.bookmarkCount) current.item = item;
    }
  });
  const candidates = [...curators.values()];
  if (!candidates.length) return undefined;
  const preferred = candidates.filter(
    ({ latest, item }) =>
      playlistItemCount(item) >= 5 && new Date(latest).getTime() >= now.getTime() - 60 * 86400000,
  );
  const pool = (preferred.length >= 2 ? preferred : candidates).sort((a, b) =>
    a.item.username.localeCompare(b.item.username, 'ko'),
  );
  const day = Math.floor(Date.UTC(now.getFullYear(), now.getMonth(), now.getDate()) / 86400000);
  return pool[day % pool.length].item;
}
export function selectCreators(featured, playlists, featuredUsername) {
  const seen = new Set();
  return [...featured.slice(1), ...playlists]
    .filter((item) => {
      if (!item.username || item.username === featuredUsername || seen.has(item.username))
        return false;
      seen.add(item.username);
      return true;
    })
    .slice(0, 12);
}
